<div class="container-fluid" *ngIf="!isRolesForm">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a style="cursor: pointer;" class="btn btn-primary" (click)="newRole()">
                Agregar Nuevo Rol
              </a>
            </div>
            <h3 class="page-title">Configuración | Rol</h3>
        </div>
    </div>
  </div>
  <!-- end page title alt- 248 -->

  <div class="row mb-5">
    <div class="col-md-12">
      <div class="table-responsive mt-4" style="border-radius: 15px;">
        <table class="table table-centered text-center">
          <thead class="table-primary">
            <tr>
              <th>Diminutivo</th>
              <th>Nombre</th>
              <th>Estatus</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <ng-content *ngFor="let rol of rolesList; let i = index">
              <tr>
                <td>{{rol.nombre}}</td>
                <td>{{rol.nombre_detalle}}</td>
                <td>{{rol.valido ? 'Activo':'Inactivo'}}</td>
                <td>
                  <input class="form-check-input" type="checkbox" id={{rol.id_rol.toString()}} value={{rol.id_rol.toString()}}  name="perfil"  [checked]="rol.valido === true" >
                  &nbsp;&nbsp;&nbsp;
                  <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="editRole(rol, rol.nombre_detalle, rol.valido)">Editar</a>
                </td>
              </tr>
            </ng-content>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-roles-form *ngIf="isRolesForm"
[editRole]="editableRole"
[editMode]="isEdit"
[user]="user"
[nombre]="nombre_rol"
[status]="status"
(vuelve)="hideForm($event)"
></app-roles-form>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
